import script from "./AcceptPaymentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptPaymentForm.vue?vue&type=script&setup=true&lang=js"

import "./AcceptPaymentForm.vue?vue&type=style&index=0&id=074470fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074470fa"]])

export default __exports__